import request from '@/request'

// 根据用户ID查询未读消息总数
export function getUnreadMsgCount() {
  return request({
    url: `/msg/getUnreadMsgCount`,
    method: 'get'
  })
}

// 获取未读消息列表
export function getUnreadMsgList(msgLang) {
  return request({
    url: `/msg/getUnreadMsgList?lang=${msgLang}`,
    method: 'get'
  })
}

// 根据条件分页查询我的消息
export function getMsgPage(msgDto) {
  return request({
    url: `/msg/getMsgPage`,
    method: 'post',
    data: msgDto
  })
}

// 将消息设置成已读
export function setMsgRead(msgReceiverIds) {
  return request({
    url: `/msg/setMsgRead`,
    method: 'post',
    data: msgReceiverIds
  })
}
// 将消息设置成未读
export function setMsgUnread(msgReceiverIds) {
  return request({
    url: `/msg/setMsgUnread`,
    method: 'post',
    data: msgReceiverIds
  })
}

// 将消息设置成全部已读
export function setAllMsgRead() {
  return request({
    url: `/msg/setAllMsgRead`,
    method: 'post'
  })
}

// 将消息设置成全部未读
export function setAllMsgUnread() {
  return request({
    url: `/msg/setAllMsgUnread`,
    method: 'post'
  })
}





// WEBPACK FOOTER //
// ./src/api/message.js